"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UpgradeModal = _interopRequireDefault(require("./UpgradeModal"));

function UILockedFeature(_ref) {
  var upgradeData = _ref.upgradeData,
      children = _ref.children,
      isDropdownOption = _ref.isDropdownOption,
      modalKey = _ref.modalKey;
  return _react.default.createElement(_UpgradeModal.default, {
    upgradeData: upgradeData,
    modalKey: modalKey
  }, function (_ref2) {
    var openUpgradeModal = _ref2.openUpgradeModal,
        preloadUpgradeModal = _ref2.preloadUpgradeModal;
    return _react.default.Children.map(children, function (child) {
      return _react.default.cloneElement(child, {
        onMouseOver: function onMouseOver() {
          if (child.props.onMouseOver) {
            var _child$props;

            (_child$props = child.props).onMouseOver.apply(_child$props, arguments);
          }

          preloadUpgradeModal();
        },
        onClick: function onClick() {
          if (child.props.onClick) {
            var _child$props2;

            (_child$props2 = child.props).onClick.apply(_child$props2, arguments);
          }

          openUpgradeModal();
        },
        className: isDropdownOption ? child.props.className + " p-y-2 p-x-5" : child.props.className,
        use: isDropdownOption ? 'unstyled' : child.props.use || 'secondary'
      });
    });
  });
}

var _default = UILockedFeature;
exports.default = _default;
module.exports = exports.default;